import React from 'react';
import defaultTo from 'ramda/src/defaultTo'

type Props = {
  isAuthorized: boolean,
  unauthorizedRender?: JSX.Element
}

const AuthorizedContent: React.FC<Props> =
  ({isAuthorized, unauthorizedRender, children}) =>
    isAuthorized
    ? <>{children}</>
    // small dance to satisfy TypeScript React.FC return
    : defaultTo<JSX.Element|null>(null)(unauthorizedRender);
export default AuthorizedContent;
